module.exports = __webpack_public_path__ + "static/img/3.14a309b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/3.png
// module id = Oeu+
// module chunks = 0